import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import GlassCard from "components/GlassCard";

function SplitCardLayout({ leftCard, rightCards, spacing = 3, minHeight = "547px" }) {
  return (
    <Grid container spacing={spacing}>
      <Grid item xs={12} lg={7} xl={8} sx={{ minHeight }}>
        <GlassCard sx={{ height: "100%" }}>
          {leftCard}
        </GlassCard>
      </Grid>
      <Grid item xs={12} lg={5} xl={4}>
        <Grid container spacing={spacing} sx={{ minHeight, height: "100%" }}>
          {rightCards.map((card, idx) => (
            <Grid item xs={12} key={idx} sx={{ height: "50%" }}>
              {card}
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

SplitCardLayout.propTypes = {
  leftCard: PropTypes.node.isRequired,
  rightCards: PropTypes.arrayOf(PropTypes.node).isRequired,
  spacing: PropTypes.number,
  minHeight: PropTypes.string,
};

SplitCardLayout.defaultProps = {
  spacing: 3,
  minHeight: "547px",
};

export default SplitCardLayout;
